
import client from './client'

export default class CodeListsService {
  constructor (key) {
    this.endpoint = `/code-list/${key}/m`
  }

  getForList (params) {
    const url = '/api' + this.endpoint
    if (!params) {
      params = {}
    }
    params.general = 1
    return client.get(url, params)
  }

  getForSelect () {
    const url = '/api' + this.endpoint
    return client.get(url)
  }

  add (item) {
    const url = '/api' + this.endpoint
    return client.post(url, item)
  }

  get (id) {
    const url = '/api' + this.endpoint + '/' + id
    return client.get(url)
  }

  put (id, item) {
    const url = '/api' + this.endpoint + '/' + id
    return client.put(url, item)
  }
}
